import React from 'react';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm, LabelNota } from '../componentes_generales/componentes_formulario/labels/';
import { formatearNumeroDecimal, formatearFechaMoment_a_String, formatearNumeroEntero } from '../../funciones_globales/format';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import moment from 'moment';
import global_axios  from '../../funciones_globales/interaccionapi';
import { connect } from 'react-redux';
import { validarCampoString } from '../../funciones_globales/utils';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import '@trendmicro/react-toggle-switch/dist/react-toggle-switch.css';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { cargarFacturasFecha, cargarDevolucionesFecha, cargarDescuentosFecha, cargarProformasFecha, cargarPedidoProcesoPorFecha,cargarArticulosPedidoFecha} from '../../actions/vendedores/act_vende01';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';

const LabelTotales = styled.label`
	display: inline-block;
	font-size: 10px;
	color: green;
`;
const LabelValorTotales = styled.label`
	display: inline-block;
	font-size: 9px;
	font-weight: bold;
	align-text: right;
`;
const ModalContainer = styled.div`
	margin-top: 30px;
	height: 300px;
	width: 700px;
`;
const LabelTipoProf = styled.label`
  display: inline;
  font-size: 10px;
  color: green;    
`;
const Hr = styled.hr`
	margin-top: 10px;
	margin-bottom: 10px;
`;
const PaginationLabels = styled.div`
    font-size: 12px;
`;

const PaginationButtons = styled.div`
    margin-bottom:10px;
`;
// const ValueForm = styled.span`
// 	display: inline-block;
// 	font-size: 12px;
// `;
class FormVende01  extends React.Component{
    constructor(props){
        super(props);
        this.state = {

            fecha_inicial: null,
            fecha_final: null,   
            usuario_final: null,   
            //Grids
            detalle_factura_data:[],
            detalle_cobranza_data :[],
            gridResumenVentas: [],
            gridResumenCobranzas: [],
            detalle_estado_pedido: [],
            detalle_estado_pedido_data:[],
            detalle_estado_pedido_data_total:[],
            detalle_estado_pedido_data_no_atendida:[],
            detalle_articulos_pedido:[],
            pagination: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
            totalResumenVentas: 0,
            totalResumenCobranzas: 0,
            totalCheque:0,
            totalChequePos:0,
            totalEfectivo:0,
            totalDetalleCobranza:0,
            totalCantidadCobranzas:0,
            totalValorPedido:0,
            totalValorProforma:0,
            totalValorProformaTransito:0,
            totalValorFacturado:0,
            totalGeneral:0,
            totalNoAtendido:0,
            isModalDetalleVisible:false,
            isModalDetalleCobranzaVisible:false,
            isModalDetalleEstadoPedidosVisible:false,
            isModalDetalleArticuloPedidosVisible:false,
            numero_pedido_movil_seleccionado:'',
            tituloModal:'',
            totalDetalle:0,
            visualizarAtendidos:false,
            colResumenVentas:[
            {   header: "Documento",
                field: "Documento",
                width: 270,
                type: "string"
            },
            {   header: "Cantidad",
                field: "Cantidad",
                width: 80,
                type: "num_entero"
            },                          
            {   header: "Valor",
                field: "Total",
                width: 100,
                type: "num_decimal"                                 
            },
            ],
            colResumenCobranzas:[
                {   header: "Forma Pago",
                    field: "Forma_Pago",
                    width: 330,
                    type: "string"
                },               
                {   header: "Valor",
                    field: "Total",
                    width: 120,
                    type: "num_decimal"                                 
                }
            ],

            detalle_factura_columns:[
            ],
            detalle_cobranza_columns:[
                {   header: "Cliente",
                    field: "Cliente",
                    width: 190,
                    type: "string"
                },
                {   header: "Fec.Cont",
                    field: "Fecha",
                    width: 80,
                    type: "string"
                },
                {   header: "Nro.Reci",
                    field: "Numero_Recibo",
                    width: 80,
                    type: "string"
                },
                {   header: "Fec.Reci",
                    field: "Fecha_Recibo",
                    width: 80,
                    type: "string"
                },
                {   header: "Efe/Dep",
                    field: "Efectivo",
                    width: 75,
                    type: "num_decimal"                                 
                },                  
                {   header: "Cheq.día-mes",
                    field: "Cheque",
                    width: 100,
                    type: "num_decimal"                                 
                },
                {   header: "Cheq.Fecha",
                    field: "Cheque_Post",
                    width: 90,
                    type: "num_decimal"                                 
                },
                
            ],
            detalle_estado_pedido_columns:[
                {   header: "Cliente",
                    field: "Cliente",
                    width: 200,
                    type: "string"
                },
                {   header: "Fecha",
                    field: "Fecha",
                    width: 70,
                    type: "string"
                },
                {   header: "Ped.Mov",
                    field: "Pedido_Movil",
                    width: 75,
                    type: "string"
                },
                {   header: "Val.Ped",
                    field: "Valor_Pedido",
                    width: 70,
                    type: "num_decimal"
                },
                {   header: "Val.Prof",
                    field: "Valor_Proforma",
                    width: 70,
                    type: "num_decimal"                                 
                },                  
                {   header: "Val.Prof.Tran.",
                    field: "Valor_Proforma_Transito",
                    width: 95,
                    type: "num_decimal"                                 
                },
                {   header: "Val.Fact",
                    field: "Valor_Factura",
                    width: 75,
                    type: "num_decimal"                                 
                },
                {   header: "Total",
                    field: "Total",
                    width: 75,
                    type: "num_decimal"                                 
                },
                {   header: "No Atendido",
                    field: "No_Atendido",
                    width: 95,
                    type: "num_decimal"                                 
                },
                
            ],
            detalle_articulos_pedido_columns:[
                {   header: "Articulo",
                    field: "Articulo",
                    width: 180,
                    type: "string"
                },
                {   header: "Precio",
                    field: "Precio",
                    width: 100,
                    type: "num_decimal"
                },
                {   header: "Cantidad Pedido",
                    field: "Cantidad_Pedido",
                    width: 135,
                    type: "num_entero"
                },
                {   header: "Cantidad Vendida",
                    field: "Cantidad_Vendido",
                    width: 130,
                    type: "num_entero"
                },
                {   header: "Cantidad No Atendida",
                    field: "No_Atendido",
                    width: 150,
                    type: "num_entero"
                },
                
            ],
        };
        this.docsResumenVentasOptions = {
            context: {
                componentParent: this
            },
            enableColResize: true,
			enableSorting: true,
			enableFilter: true,
			rowSelection: "single",
            suppressScrollOnNewData: true,
            onRowSelected: ((event)=>{
                // if(event.node.selected === true){                    
                //     let seleccion = this.apidocsPendientes.getSelectedRows();
                //     this.addDocumentoPendiente(seleccion[0]);
                // }
            }),
            onRowDoubleClicked: event => {
                let documento = event.data.Documento;
                let QueryString = "";
                    QueryString += "?id_vendedor="+this.state.usuario_final.OficialCredito;
                    QueryString += "&fecha_inicial="+this.state.fecha_inicial.format("DD/MM/YYYY");
                    QueryString += "&fecha_final="+this.state.fecha_final.format("DD/MM/YYYY");
                //this.getAsientoById(movimiento);
                if(documento.trim()!=="Facturas".trim()){
                    let detalle_factura_columns=[
                        {   header: "Cliente",
                            field: "Cliente",
                            width: 300,
                            type: "string"
                        },
                        {   header: "Fecha",
                            field: "Fecha",
                            width: 100,
                            type: "string"
                        },
                        {   header: "Nro.Fact",
                            field: "Numero_Factura",
                            width: 100,
                            type: "string"
                        }, 
                        {
                            header: "Nro.Devol",
                            field: "Numero_Documento",
                            width: 100,
                            type: "string"
                        },                  
                        {   header: "Valor",
                            field: "Valor",
                            width: 100,
                            type: "num_decimal"                                 
                        },
                    ]
                    
                    if(documento.trim()==="Devoluciones".trim()){
                        this.cargarDevolucionesPorFecha(QueryString);
                    }else if(documento.trim()==="Descuento Comercial".trim()){
                         detalle_factura_columns=[
                            {   header: "Cliente",
                                field: "Cliente",
                                width: 300,
                                type: "string"
                            },
                            {   header: "Fecha",
                                field: "Fecha",
                                width: 100,
                                type: "string"
                            },
                            {   header: "Nro.Fact",
                                field: "Numero_Factura",
                                width: 100,
                                type: "string"
                            }, 
                            {
                                header: "Nro.Nota Créd",
                                field: "Credito",
                                width: 100,
                                type: "string"
                            },                  
                            {   header: "Valor",
                                field: "Valor",
                                width: 100,
                                type: "num_decimal"                                 
                            },
                        ]
                        this.cargarDescuentosPorFecha(QueryString);
                    }else if(documento.trim()==="Pedido en Proceso".trim()){
                        detalle_factura_columns=[
                            {   header: "Cliente",
                                field: "Cliente",
                                width: 350,
                                type: "string"
                            },
                            {   header: "Fecha",
                                field: "Fecha",
                                width: 100,
                                type: "string"
                            }, 
                            {   header: "Nro.Doc",
                                field: "Numero_Documento",
                                width: 150,
                                type: "string"
                            },                                      
                            {   header: "Valor",
                                field: "Valor",
                                width: 100,
                                type: "num_decimal"                                 
                            },
                        ]
                        this.cargarPedidoProcesoFecha(QueryString);
                    }
                    else{
                        detalle_factura_columns=[
                        {   header: "Cliente",
                            field: "Cliente",
                            width: 300,
                            type: "string"
                        },
                        {   header: "Fecha",
                            field: "Fecha",
                            width: 100,
                            type: "string"
                        },
                        {   header: "Ped.Movil",
                            field: "Pedido_Movil",
                            width: 100,
                            type: "string"
                        },              
                        {   header: "Val.Proforma",
                            field: "Valor",
                            width: 110,
                            type: "num_decimal"                                 
                        },
                        {   header: "Tipo",
                            field: "Tipo",
                            width: 100,
                            type: "string"
                        }, 
                    ]
                        this.cargarProformasPorFecha(QueryString);
                    }
                    this.setState({detalle_factura_columns: detalle_factura_columns});
                }else{

                    let detalle_factura_columns=[
                        {   header: "Cliente",
                            field: "Cliente",
                            width: 239,
                            type: "string"
                        },
                        {   header: "Fecha",
                            field: "Fecha",
                            width: 100,
                            type: "string"
                        },
                        {   header: "Nro.Fact",
                            field: "Numero",
                            width: 90,
                            type: "string"
                        }, 
                        {   header: "Ped.Mov",
                            field: "Pedido_Movil",
                            width: 90,
                            type: "string"
                        },   
                        {   header: "Val.Ped",
                            field: "Valor_Pedido",
                            width: 90,
                            type: "num_decimal"                                 
                        },              
                        {   header: "Val.Fact",
                            field: "Valor",
                            width: 90,
                            type: "num_decimal"                                 
                        },  
                    ]
                    this.setState({detalle_factura_columns: detalle_factura_columns});
                    this.cargarFacturasPorFecha(QueryString);
                }
                this.setState({isModalDetalleVisible: true, tituloModal: documento});

                
			},
            onRowDataChanged:((event)=>{}),
            onCellValueChanged:((event)=>{}),
            onCellEditingStarted:((event)=> {})
        };
        this.gridDetalleFacturaOptions = {
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
            rowSelection: "single",
            paginationAutoPageSize:true,
            pagination: true,
            suppressPaginationPanel: true,
            suppressScrollOnNewData: true,
            onRowDoubleClicked: event => {
                let documento = event.data;
                //this.getAsientoById(movimiento);
                this.generarReporte(documento) 
			},
            onPaginationChanged: () => {
                if(!this.apiDetalleFactura){
                    return;
                }
                let totalFilas = this.apiDetalleFactura.paginationGetRowCount();
                let totalFilasPorPagina = this.apiDetalleFactura.paginationGetPageSize();
                let ultimaFilaPagina = (totalFilasPorPagina * (this.apiDetalleFactura.paginationGetCurrentPage()+1));
                let indexPage = this.apiDetalleFactura.paginationGetCurrentPage();

                if( ultimaFilaPagina >  totalFilas){
                    ultimaFilaPagina = totalFilas;
                }
           
                let pagination = {
                    totalFilas: totalFilas,
                    totalFilasPorPagina: totalFilasPorPagina,
                    primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
                    ultimaFilaPagina: ultimaFilaPagina
                };

                this.setState({pagination});
			},
        };
        this.gridDetalleArticuloPedidoOptions = {
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
            rowSelection: "single",
            paginationAutoPageSize:true,
            pagination: true,
            suppressPaginationPanel: true,
            suppressScrollOnNewData: true,
            onPaginationChanged: () => {
                if(!this.apiDetalleArticuloPedido){
                    return;
                }
                let totalFilas = this.apiDetalleArticuloPedido.paginationGetRowCount();
                let totalFilasPorPagina = this.apiDetalleArticuloPedido.paginationGetPageSize();
                let ultimaFilaPagina = (totalFilasPorPagina * (this.apiDetalleArticuloPedido.paginationGetCurrentPage()+1));
                let indexPage = this.apiDetalleArticuloPedido.paginationGetCurrentPage();

                if( ultimaFilaPagina >  totalFilas){
                    ultimaFilaPagina = totalFilas;
                }
           
                let pagination = {
                    totalFilas: totalFilas,
                    totalFilasPorPagina: totalFilasPorPagina,
                    primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
                    ultimaFilaPagina: ultimaFilaPagina
                };

                this.setState({pagination});
			},
        };
        this.gridDetalleCobranzaOptions = {
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
            rowSelection: "single",
            paginationAutoPageSize:true,
            pagination: true,
            suppressPaginationPanel: true,
            suppressScrollOnNewData: true,
            // onRowDoubleClicked: event => {
            //     let documento = event.data;
            //     //this.getAsientoById(movimiento);
            //     this.generarReporte(documento) 
			// },
            onPaginationChanged: () => {

                if(!this.apiDetalleCobranza){
                    return;
                }
                let totalFilas = this.apiDetalleCobranza.paginationGetRowCount();
                let totalFilasPorPagina = this.apiDetalleCobranza.paginationGetPageSize();
                let ultimaFilaPagina = (totalFilasPorPagina * (this.apiDetalleCobranza.paginationGetCurrentPage()+1));
                let indexPage = this.apiDetalleCobranza.paginationGetCurrentPage();

                if( ultimaFilaPagina >  totalFilas){
                    ultimaFilaPagina = totalFilas;
                }
                let pagination = {
                    totalFilas: totalFilas,
                    totalFilasPorPagina: totalFilasPorPagina,
                    primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
                    ultimaFilaPagina: ultimaFilaPagina
                };

                this.setState({pagination});
			},
        };
        this.gridDetalleEstadoPedido = {
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
            rowSelection: "single",
            paginationAutoPageSize:true,
            pagination: true,
            suppressPaginationPanel: true,
            suppressScrollOnNewData: true,
            onRowDoubleClicked: event => {
                let documento = event.data;
                if(documento.No_Atendido >0){
                    this.setState({numero_pedido_movil_seleccionado: documento.Pedido_Movil});
                    this.generarConsultaDetalleArticuloPedido(documento);
                }
               
			},
            onPaginationChanged: () => {

                if(!this.apiDetalleEstadoPedido){
                    return;
                }
                let totalFilas = this.apiDetalleEstadoPedido.paginationGetRowCount();
                let totalFilasPorPagina = this.apiDetalleEstadoPedido.paginationGetPageSize();
                let ultimaFilaPagina = (totalFilasPorPagina * (this.apiDetalleEstadoPedido.paginationGetCurrentPage()+1));
                let indexPage = this.apiDetalleEstadoPedido.paginationGetCurrentPage();

                if( ultimaFilaPagina >  totalFilas){
                    ultimaFilaPagina = totalFilas;
                }
                let pagination = {
                    totalFilas: totalFilas,
                    totalFilasPorPagina: totalFilasPorPagina,
                    primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
                    ultimaFilaPagina: ultimaFilaPagina
                };

                this.setState({pagination});
			},
		};
        this.docsResumenCobranzasOptions = {
            context: {
                componentParent: this
            },
            rowSelection: "single",
            suppressRowClickSelection:true,
            singleClickEdit: true,
            enableColResize: true,
            enableFilter: true,
            enableSorting: true,
            enableCellChangeFlash: true,
            onRowSelected: ((event)=>{
                // if(event.node.selected === true){                    
                //     let seleccion = this.apidocsPendientes.getSelectedRows();
                //     this.addDocumentoPendiente(seleccion[0]);
                // }
            }),
            onRowDataChanged:((event)=>{}),
            onCellValueChanged:((event)=>{}),
            onCellEditingStarted:((event)=> {})
        };
        //OP OVERCONTROLLS
        this.changeComponents = this.changeComponents.bind(this);
        //this.changeYear = this.changeYear.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.limpiarGrid = this.limpiarGrid.bind(this);
        this.generarConsulta = this.generarConsulta.bind(this);
        this.generarConsultaDetalleCobranza=this.generarConsultaDetalleCobranza.bind(this);
        this.cargarOptionsResumenVentas= this.cargarOptionsResumenVentas.bind(this);
        this.cargarOptionsResumenCobranzas= this.cargarOptionsResumenCobranzas.bind(this);
        this.generarConsultaDetalleEstadoPedido = this.generarConsultaDetalleEstadoPedido.bind(this);
        this.generarConsultaDetalleArticuloPedido = this.generarConsultaDetalleArticuloPedido.bind(this);
        //GRID
        this.onGridDocsResumenVenta = this.onGridDocsResumenVenta.bind(this);
        this.onGridDocsResumenCobranzas = this.onGridDocsResumenCobranzas.bind(this);
        this.onGridDetalleFacturaReady= this.onGridDetalleFacturaReady.bind(this);
        this.onGridDetalleCobranzaReady= this.onGridDetalleCobranzaReady.bind(this);
        this.onGridDetalleEstadoPedidoReady= this.onGridDetalleEstadoPedidoReady.bind(this);
        this.onGridDetalleArticuloPedidoReady= this.onGridDetalleArticuloPedidoReady.bind(this);
    }
    cargarFacturasPorFecha(query){
		if( query ){
			this.props.cargarFacturasFecha(query).then(
				() => {
					let detalle_factura_data = [];
                    let totalDetalle = 0;
                    this.props.facturas.forEach((itemFactura, i) => {
                        totalDetalle += parseFloat(itemFactura.valor);
                         detalle_factura_data.push({
							...itemFactura,
							Cliente: itemFactura.Cliente,
							Fecha:itemFactura.Fecha,
                            Numero: itemFactura.Numero_Documento,
                            Valor: itemFactura.valor,
                            Id: itemFactura.Factura,
                            Identificador: 'Fac',
                            Pedido_Movil: itemFactura.Pedido_Movil,
                            Valor_Pedido: itemFactura.Valor_Pedido
						});
					});
					this.setState({
                        detalle_factura_data,
                        totalDetalle
                    });
				}
			);
		}else{
			alert("No se poseen todos los datos para realizar la petición");
		}
    }
    cargarDevolucionesPorFecha(query){
		if( query ){
			this.props.cargarDevolucionesFecha(query).then(
				() => {
					let detalle_factura_data= [];
                    let totalDetalle = 0;
                    this.props.devoluciones.forEach((itemDevolucion, i) => {
                        totalDetalle += parseFloat(itemDevolucion.valor);
                         detalle_factura_data.push({
							...itemDevolucion,
							Cliente: itemDevolucion.Cliente,
							Fecha: itemDevolucion.Fecha,
                            Numero_Documento: itemDevolucion.Numero_Documento,
                            Numero_Factura: itemDevolucion.Numero_Factura,
                            Valor: itemDevolucion.valor,
                            Id: itemDevolucion.Devolucion,
                            Identificador: 'Dev'
						});
					});

					this.setState({
                        detalle_factura_data,
                        totalDetalle
					});
				}
			);
		}else{
			alert("No se poseen todos los datos para realizar la petición");
		}
    }
    cargarDescuentosPorFecha(query){
		if( query ){
			this.props.cargarDescuentosFecha(query).then(
				() => {
					let detalle_factura_data= [];
                    let totalDetalle = 0;
                    this.props.descuentos.forEach((itemDescuento, i) => {
                         totalDetalle += parseFloat(itemDescuento.valor);
                         detalle_factura_data.push({
							...itemDescuento,
							Cliente: itemDescuento.Cliente,
							Fecha: itemDescuento.Fecha,
                            Numero_Documento: itemDescuento.Numero_Documento,
                            Numero_Factura: itemDescuento.Numero_Factura,
                            Valor: itemDescuento.valor,
                            Id: itemDescuento.Credito,
                            Identificador: 'Des'
						});
					});

					this.setState({
                        detalle_factura_data,
                        totalDetalle
					});
				}
			);
		}else{
			alert("No se poseen todos los datos para realizar la petición");
		}
    }
    cargarPedidoProcesoFecha(query){
		if( query ){
			this.props.cargarPedidoProcesoPorFecha(query).then(
				() => {
					let detalle_factura_data= [];
                    let totalDetalle = 0;
                    this.props.pedidoProcesos.forEach((itemPedido, i) => {
                         totalDetalle += parseFloat(itemPedido.Valor);
                         detalle_factura_data.push({
							...itemPedido,
							Cliente: itemPedido.Cliente,
							Fecha: itemPedido.Fecha,
                            Numero_Documento: itemPedido.Numero_Documento,
                            Valor: itemPedido.Valor,
                            Id: itemPedido.Numero_Documento,
                            Identificador: 'Pedi'
						});
					});

					this.setState({
                        detalle_factura_data,
                        totalDetalle
					});
				}
			);
		}else{
			alert("No se poseen todos los datos para realizar la petición");
		}
    }
    cargarProformasPorFecha(query){
		if( query ){
			this.props.cargarProformasFecha(query).then(
				() => {
					let detalle_factura_data= [];
                    let totalDetalle = 0;
                    this.props.proformas.forEach((itemProforma, i) => {
                         totalDetalle += parseFloat(itemProforma.valor);
                         detalle_factura_data.push({
							...itemProforma,
							Cliente: itemProforma.Cliente,
							Fecha: itemProforma.Fecha,
                            Numero_Documento: itemProforma.Numero_Documento,
                            Pedido_Movil: itemProforma.Pedido_Movil,
                            Valor: itemProforma.valor,
                            Id: itemProforma.Numero_Documento,
                            Tipo: ((itemProforma.Tipo==='T')?'Transito':''),
                            Identificador: 'Pro',
                            Valor_Pedido: itemProforma.Valor_Pedido
						});
					});

					this.setState({
                        detalle_factura_data,
                        totalDetalle
					});
				}
			);
		}else{
			alert("No se poseen todos los datos para realizar la petición");
		}
    }
    generarConsultaDetalleEstadoPedido(){
        let QueryString = "";
        QueryString += "?id_vendedor="+this.state.usuario_final.OficialCredito;
        QueryString += "&fecha_inicial="+this.state.fecha_inicial.format("DD/MM/YYYY");
        QueryString += "&fecha_final="+this.state.fecha_final.format("DD/MM/YYYY");
        global_axios({
            method: 'GET',
            url: '/vendedoresconsulta/cargar-detalle-estado-pedido-fecha/' + QueryString
        })
        .then( response => {
            let detalleEstadoPedido = response.data.detalleEstadoPedido;
            let detalle_estado_pedido_data = [];
            let detalle_estado_pedido_data_no_atendida = [];
            let totalValorPedido=0;
            let totalValorProforma=0;
            let totalValorProformaTransito=0;
            let totalValorFacturado=0;
            let totalGeneral=0;
            let totalNoAtendido=0;
            let totalHorizontal=0;
            detalleEstadoPedido
            .forEach((item, i) => {
                let valorPedido = parseFloat(item.Valor_Pedido);
                let valorProforma= parseFloat(item.Valor_Proforma);
                let valorProformaTransito= parseFloat(item.Valor_Proforma_Transito);
                let valorFacturado= parseFloat(item.Valor_Factura);
                let noAtendido= 0;
                totalHorizontal=parseFloat(valorProforma)+parseFloat(valorProformaTransito)+parseFloat(valorFacturado);
                totalValorPedido+=valorPedido;
                totalValorProforma+=valorProforma;
                totalValorProformaTransito+=valorProformaTransito;
                totalValorFacturado+=valorFacturado;
                totalGeneral+= parseFloat(totalHorizontal);
                noAtendido= item.Valor_Pedido-totalHorizontal;
                detalle_estado_pedido_data.push({
					Cliente: item.Cliente,
					Fecha: item.Fecha,
                    Pedido_Movil: item.Pedido,
                    Valor_Pedido: item.Valor_Pedido,
                    Valor_Proforma: item.Valor_Proforma,
                    Valor_Proforma_Transito: item.Valor_Proforma_Transito,
                    Valor_Factura: item.Valor_Factura,
                    Total: totalHorizontal,
                    No_Atendido: item.Valor_Pedido-totalHorizontal
                });
                if(noAtendido>0){
                    detalle_estado_pedido_data_no_atendida.push({
                        Cliente: item.Cliente,
                        Fecha: item.Fecha,
                        Pedido_Movil: item.Pedido,
                        Valor_Pedido: item.Valor_Pedido,
                        Valor_Proforma: item.Valor_Proforma,
                        Valor_Proforma_Transito: item.Valor_Proforma_Transito,
                        Valor_Factura: item.Valor_Factura,
                        Total: totalHorizontal,
                        No_Atendido: item.Valor_Pedido-totalHorizontal
                    });
                }
            });
            totalNoAtendido= totalValorPedido - totalGeneral;
            this.setState({isModalDetalleEstadoPedidosVisible:true});
            this.setState({
                detalle_estado_pedido_data,
                detalle_estado_pedido_data_total:detalle_estado_pedido_data,
                detalle_estado_pedido_data_no_atendida,
                totalValorPedido,
                totalValorProforma,
                totalValorProformaTransito,
                totalValorFacturado,
                totalGeneral,
                totalNoAtendido
            });
            this.props.cambiar_VisualizacionLoading(false);
        })
        .catch( error => {
        	this.props.cambiar_VisualizacionLoading(false);				
			alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);
        });
        
    }
    generarConsultaDetalleArticuloPedido(documento){
        let QueryString = "";
        QueryString += "?id_pedido="+this.state.numero_pedido_movil_seleccionado;
        if( QueryString ){
			this.props.cargarArticulosPedidoFecha(QueryString).then(
                () => {
                    let detalle_articulos_pedido= [];
                    console.log(this.props.articulosPedido)
                    this.props.articulosPedido.forEach((itemPedido, i) => {
                        detalle_articulos_pedido.push({
							...itemPedido,
							Articulo: itemPedido.Articulo,
							Precio: itemPedido.Precio,
                            Cantidad_Pedido: itemPedido.Cantidad_Pedido,
                            Cantidad_Vendido: itemPedido.Cantidad_Vendida,
                            No_Atendido: itemPedido.No_Atendido,
						});
					});

					this.setState({isModalDetalleArticuloPedidosVisible:true});
                    this.setState({
                        detalle_articulos_pedido,
                    });
                    this.props.cambiar_VisualizacionLoading(false);
                        }
                    );
		}else{
			alert("No se poseen todos los datos para realizar la petición");
		}
    }
    changeComponents(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
    }
    onGridDocsResumenVenta(params){
        this.apiDocsResumenVenta= params.api;
        this.columnApiDocsResumenVenta = params.columnApi;
    }
    onGridDocsResumenCobranzas(params){
        this.apiDocsResumenCobranza= params.api;
        this.columnApiDocsResumenCobranza = params.columnApi;
    }
    onGridDetalleFacturaReady(params) {
		this.apiDetalleFactura = params.api;
		this.gridApiColumnaDetalleFactura = params.columnApi;
    }
    onGridDetalleCobranzaReady(params) {
		this.apiDetalleCobranza= params.api;
		this.gridApiColumnaDetalleCobranza = params.columnApi;
    }
    onGridDetalleEstadoPedidoReady(params) {
		this.apiDetalleEstadoPedido= params.api;
		this.gridApiColumnaDetalleEstadoPedido = params.columnApi;
    }
    onGridDetalleArticuloPedidoReady(params) {
		this.apiDetalleArticuloPedido= params.api;
		this.gridApiColumnaDetalleArituculoPedido = params.columnApi;
    }
    limpiarGrid(){
		this.setState({
            gridResumenVentas:[],
            gridResumenCobranzas:[],
            detalle_factura_data:[],
            detalle_cobranza_data:[],
		});
    }
    generarReporte(documento){    
        let documentoId = documento.Id;
        if(documento.Identificador.trim()!=="Pedi".trim()){
            if (!validarCampoString(documentoId, 6)){
                alert('No ha seleccionado un documento para imprimir.');
                return;
              }
            if(documento.Identificador.trim()==="Fac".trim()){
                visualizarReporteEnPdf(`&rpt=3&param1=${documentoId}`);
            }else{
                if(documento.Identificador.trim()==="Dev".trim()){
                    visualizarReporteEnPdf('&rpt=4&param1=' + documentoId);
                }else if(documento.Identificador.trim()==="Des".trim()){
                    visualizarReporteEnPdf(`&rpt=71&param1=${documentoId}`);
                }else{
                    visualizarReporteEnPdf('&rpt=2&param1=' + documentoId);
                }
            }
        }
  
    }
    getMonday( fecha ) {
        var date= new Date(fecha);
        var day = date.getDay() || 7;  
        if( day !== 1 ) 
            date.setHours(-24 * (day - 1)); 
        return date;
    }
    cargarDatosEstadosPedidoEspecifico(){
      
        this.setState({ visualizarAtendidos: !this.state.visualizarAtendidos})
        if(this.state.visualizarAtendidos){
            this.setState({ detalle_estado_pedido_data: this.state.detalle_estado_pedido_data_total})
        }else{
            this.setState({ detalle_estado_pedido_data: this.state.detalle_estado_pedido_data_no_atendida});
        }
    }
    cargarOptionsResumenVentas(){
        this.props.cambiar_VisualizacionLoading(true);
        let QueryString = "";
        QueryString += "?id_vendedor="+this.state.usuario_final.OficialCredito;
		QueryString += "&fecha_inicial="+this.state.fecha_inicial.format("DD/MM/YYYY");
		QueryString += "&fecha_final="+this.state.fecha_final.format("DD/MM/YYYY");

        global_axios({
            method: 'GET',
            url: '/vendedoresconsulta/' + QueryString
        })
        .then( response => {
            let data = response.data.datos;
            let gridResumenVentas = [];
            let totalResumenVentas=0;
            data.forEach((item, i) => {
                if(item.Documento!=='Pedido en Proceso'){
                    let valor = parseFloat(item.Total);
                    totalResumenVentas+=valor;
                }
               
                gridResumenVentas.push({
					Documento: item.Documento,
					Cantidad: item.Cantidad,
					Total: item.Total,
				});
            });
            this.setState({
                gridResumenVentas,
                totalResumenVentas
            });
            this.props.cambiar_VisualizacionLoading(false);
        })
        .catch( error => {
        	this.props.cambiar_VisualizacionLoading(false);				
			alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);
        });


    }
    cargarOptionsResumenCobranzas(){
        this.props.cambiar_VisualizacionLoading(true);
        let QueryString = "";
        QueryString += "?id_vendedor="+this.state.usuario_final.OficialCredito;
		QueryString += "&fecha_inicial="+this.state.fecha_inicial.format("DD/MM/YYYY");
		QueryString += "&fecha_final="+this.state.fecha_final.format("DD/MM/YYYY");

        global_axios({
            method: 'GET',
            url: '/vendedoresconsulta/cargar-resumen-cobranzas-fecha/' + QueryString
        })
        .then( response => {
            let data = response.data.datosCobranzas;
            let gridResumenCobranzas = [];
            let totalResumenCobranzas=0;
            data.forEach((item, i) => {
                let valor = parseFloat(item.Total);
                totalResumenCobranzas+=valor;
                gridResumenCobranzas.push({
					Forma_Pago: item.Forma_Pago,
					Total: item.Total,
				});
            });
            this.setState({
                gridResumenCobranzas,
                totalResumenCobranzas
            });
            global_axios({
                method: 'GET',
                url: '/vendedoresconsulta/cargar-cantidad-cobranzas-fecha/' + QueryString
            }).then( response => {
                let data = response.data.cantidadCobranzas; 
                let totalCantidadCobranzas= data.CantidadCobranza;
                this.setState({
                    totalCantidadCobranzas,
                });
                this.props.cambiar_VisualizacionLoading(false);
            })
        })
        .catch( error => {
        	this.props.cambiar_VisualizacionLoading(false);				
			alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);
        });


    }
    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{

                reject('No existe movimiento a presentar...');
            });
        });
    }
    componentDidMount(){
        Promise.all([
            this.props.generar_LogAuditoriaIngresoForm('1101')
         ])
        .then(() => {

            //Asignacion de Fecha
            let fechaProceso = getFechaProcesoPorModulo('11');
           let fecha_proceso_moment= moment(fechaProceso, "DD/MM/YYYY");
           let fecha_inicio_semana= this.getMonday(fecha_proceso_moment);
           let fecha_inicial= moment(fecha_inicio_semana, "DD/MM/YYYY");
           let copia_fecha_inicial= moment(fecha_inicio_semana, "DD/MM/YYYY");
           let fecha_final = copia_fecha_inicial.add(5,'days');
            this.setState({fecha_inicial: fecha_inicial, fecha_final: fecha_final})
            global_axios({
                method: 'GET',
                url: '/usuarios/' + this.props.usuario
            })
            .then( response => {
                this.setState({usuario_final : response.data})
            }).catch( error => {
                alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);
            });
            
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('1101');
    }

    validacionFechaTrabajo(fechaProceso, fecha){
        
        var respuesta;
        var i_fecha = formatearFechaMoment_a_String(fecha)
        let fechaPartProceso = fechaProceso.split('/');
        let fechaPart = i_fecha.split('/');

        //Evaluacion Año
        if(fechaPart[2]===fechaPartProceso[2]){
            respuesta = true;
        }else{
            respuesta = false;
        }

        return respuesta;
    }

    limpiar(){
        //Asignacion de Fecha
        
        let totalDetalle=0;
        let totalResumenVentas=0;
        let totalResumenCobranzas=0;
        let totalDetalleCobranza=0;
        let totalCantidadCobranzas=0;
        let totalCheque=0;
        let totalChequePos=0;
        let totalEfectivo=0;
        this.limpiarGrid();
        this.setState({
            totalDetalle, 
            totalResumenVentas,
            totalResumenCobranzas,
            totalDetalleCobranza,
            totalCantidadCobranzas,
            totalCheque,
            totalChequePos,
            totalEfectivo
        })

    }

    generarConsulta(){
        var continuar = true;
        var error = "";
        var errorAnio = false;
        
        let fechaProceso = getFechaProcesoPorModulo('11');
        if(this.validacionFechaTrabajo(fechaProceso, this.state.fecha_final)===false){
            errorAnio = true;
            continuar = false;
            error=error+'- La fecha hasta no esta dentro del año vigente.\n';
        }

        if(this.validacionFechaTrabajo(fechaProceso, this.state.fecha_inicial)===false){
            errorAnio = true;
            continuar = false;
            error=error+'- La fecha desde no esta dentro del año vigente.\n';
        }
        //Validacion FECHA DESDE > FECHA HASTA
        if(this.state.fecha_final.diff(this.state.fecha_inicial, 'days')<0 && errorAnio === false){
            continuar = false;
            error=error+'- La fecha desde debe ser menor a: '+formatearFechaMoment_a_String(this.state.fecha_final)+'\n';
        }
        //Validación consulta solo de 31 días
        if(this.state.fecha_final.diff(this.state.fecha_inicial, 'days')>31){
            continuar = false;
            error=error+'- Las fechas deben encontrarse en un rango menor o igual a 31 días';
        }
        if(continuar === true){
            this.limpiarGrid();
            this.cargarOptionsResumenVentas();
            this.cargarOptionsResumenCobranzas();
          
        }else{
            alert(error);
        }
    }
    generarConsultaDetalleCobranza(){
        let QueryString = "";
        QueryString += "?id_vendedor="+this.state.usuario_final.OficialCredito;
        QueryString += "&fecha_inicial="+this.state.fecha_inicial.format("DD/MM/YYYY");
        QueryString += "&fecha_final="+this.state.fecha_final.format("DD/MM/YYYY");
        global_axios({
            method: 'GET',
            url: '/vendedoresconsulta/cargar-detalle-cobranzas-fecha/' + QueryString
        })
        .then( response => {
            let detalleCobranzas = response.data.detalleCobranzas;
            let detalle_cobranza_data = [];
            let totalEfectivo=0;
            let totalCheque=0;
            let totalChequePos=0;
            let totalDetalleCobranza=0;

            detalleCobranzas.forEach((item, i) => {
                let valorEfectivo = parseFloat(item.Efectivo);
                let valorCheque= parseFloat(item.Cheque);
                let valorChequePos= parseFloat(item.Cheque_Post);
                totalEfectivo+=valorEfectivo;
                totalCheque+=valorCheque;
                totalChequePos+=valorChequePos;
                detalle_cobranza_data.push({
					Cliente: item.Cliente,
					Fecha: item.Fecha,
                    Numero_Recibo: item.Numero_Recibo,
                    Numero_Cobranza: item.Numero_Cobranza,
                    Efectivo: item.Efectivo,
                    Cheque: item.Cheque,
                    Cheque_Post: item.Cheque_Post
				});
            });
            totalDetalleCobranza=totalCheque+totalChequePos+totalEfectivo;
            this.setState({isModalDetalleCobranzaVisible: true});
            this.setState({
                detalle_cobranza_data,
                totalEfectivo,
                totalCheque,
                totalChequePos,
                totalDetalleCobranza
            });
            this.props.cambiar_VisualizacionLoading(false);
        })
        .catch( error => {
        	this.props.cambiar_VisualizacionLoading(false);				
			alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);
        });
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Ventas y Cobranzas</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-xs-12 col-sm-12'>{/*col-sm-offset-4 col-sm-pull-4 - col-sm-offset-4 col-sm-pull-4*/}
                        <Row>
                            <ContainerCol className='col-xs-1 col-sm-1' margen_arriba='15' margen_abajo='8'>
                                <LabelForm>Desde:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-xs-3 col-sm-3 ' margen_arriba='15' margen_abajo='4'>
                                <PickerFecha fechaSeleccionada={this.state.fecha_inicial} func_onChange={(fechaEscogida)=>{this.setState({fecha_inicial: fechaEscogida});}}/>
                            </ContainerCol>
                            <ContainerCol className='col-xs-1 col-sm-1' margen_arriba='15' margen_abajo='4'>
                                <LabelForm>Hasta:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-xs-3 col-sm-3' margen_arriba='15' margen_abajo='4'>
                                <PickerFecha fechaSeleccionada={this.state.fecha_final} func_onChange={(fechaEscogida)=>{this.setState({fecha_final: fechaEscogida});}}/>
                            </ContainerCol>
                            <ContainerCol className='col-xs-4 col-sm-4'margen_arriba={15}>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm'  onClick={this.generarConsulta}><i className="fa fa-search" aria-hidden="true"/>Buscar</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i></button>
                            </div>
                            </ContainerCol>
                        </Row>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12 ' >
                            <LabelForm>Resumen Ventas</LabelForm>
                            <AgGridRender  altura='140px'  data={this.state.gridResumenVentas} columnas={this.state.colResumenVentas}
                            gridOptions={this.docsResumenVentasOptions} onGridReady={this.onGridDocsResumenVenta} 
                            alturaRow={20}/>
                        </ContainerCol>
                    </Row>
                    <div className="col-sm-12">
                        <Row>
                            <ContainerCol className="col-xs-6 col-sm-4 pull-right">
                                <LabelTotales>Total Ventas: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalResumenVentas)}</LabelValorTotales>
                            </ContainerCol>
                            <LabelNota>{'Doble click para ver el detalle de los documentos'}</LabelNota>
                            {/* <LabelNota>{'Click derecho para exportar la tabla a excel'}</LabelNota> */}
                        </Row>
                    </div>
                    <div className='btn-group pull-right'>                            
                        <button type='button' className='btn btn-link btn-xs' disabled={this.state.gridResumenVentas.length===0}  onClick={this.generarConsultaDetalleEstadoPedido}><i className="fa fa-file-o" aria-hidden="true"/> Estados Pedido</button>  
                    </div>
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba={10}>
                            <LabelForm>Resumen Cobranzas</LabelForm>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-link btn-xs' disabled={this.state.gridResumenCobranzas.length===0}  onClick={this.generarConsultaDetalleCobranza}><i className="fa fa-eye" aria-hidden="true"/> Detalle Cobranza</button>  
                            </div>
                            <AgGridRender   altura='120px' data={this.state.gridResumenCobranzas} columnas={this.state.colResumenCobranzas}
                            gridOptions={this.docsResumenCobranzasOptions} onGridReady={this.onGridDocsResumenCobranzas} alturaRow={20}/>
                            <div className="col-xs-12 col-sm-12">
                                <Row>
                                    <ContainerCol className="col-xs-8 col-sm-8">
                                        <LabelTotales>Total Cantidad: </LabelTotales> <LabelValorTotales>{formatearNumeroEntero(this.state.totalCantidadCobranzas)}</LabelValorTotales>
                                    </ContainerCol>
                                    <ContainerCol className="col-xs-4 col-sm-4 ">
                                        <LabelTotales>Total Cobranzas: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalResumenCobranzas)}</LabelValorTotales>
                                    </ContainerCol>
                                    {/* <LabelNota>{'Click derecho para exportar la tabla a excel'}</LabelNota> */}
                                </Row>
                            </div>
                        </ContainerCol>
                    </Row>
                    
                </CuerpoForm>

                <ModalResponsive closeOut={true} open={this.state.isModalDetalleVisible} onClose={() => this.setState({isModalDetalleVisible:false})}>
					<ModalContainer>
						<Row>
							<ContainerCol className='col-xs-12 col-sm-12' align="center">
								<h4><strong>Detalle {this.state.tituloModal}</strong></h4>
								<Hr />
							</ContainerCol>
						</Row>
						<Row>
							<ContainerCol className="col-xs-12 col-sm-12">
								<Row>
									<ContainerCol className="col-xs-12 col-sm-12">
										<AgGridRender
											altura='150px'
											data={this.state.detalle_factura_data}
											columnas={this.state.detalle_factura_columns}
											onGridReady={this.onGridDetalleFacturaReady}
                                            gridOptions={this.gridDetalleFacturaOptions}
                                            alturaRow={20}
										/>
									</ContainerCol>
								</Row>
                                <Row>
                                    <div className="col-xs-12 col-sm-12">
                                        <Row>
                                            <ContainerCol className="col-xs-12 col-sm-12">
                                                <PaginationLabels>
                                                    {this.state.pagination.primaraFilaPagina} a {this.state.pagination.ultimaFilaPagina} de {this.state.pagination.totalFilas}
                                                </PaginationLabels>
                                                <ContainerCol className="xol-xs-2 col-sm-2 pull-right">
                                                    <LabelTotales>Total: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalDetalle)}</LabelValorTotales>
                                                </ContainerCol>
                                                <PaginationButtons>
                                                    <div className="btn-group btn-group-xs" role="group">
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleFactura.paginationGoToFirstPage()}>
                                                            <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                                        </button>
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleFactura.paginationGoToPreviousPage()}>
                                                            <i className="fa fa-angle-left fa-fw"></i>Anterior
                                                        </button>
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleFactura.paginationGoToNextPage()}>
                                                            Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                                        </button>
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleFactura.paginationGoToLastPage()}>
                                                            Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                                        </button>
                                                    </div>
                                                </PaginationButtons>
                                            </ContainerCol>
                                        </Row>
                                    </div>

                                    <div className="col-sm-12">
                                        <Row>
                                        <ContainerCol className="col-xs-12 col-sm-12">
                                            <div className="col-xs-5 col-sm-5">
                                                <LabelNota>{'Doble click para ver el documento en PDF'}</LabelNota>
                                            </div>
                                            {/* <div className="col-xs-5 col-sm-5">
                                                <LabelNota>{'Click derecho para exportar la tabla a excel'}</LabelNota>
                                            </div> */}
                                        </ContainerCol>
                                        </Row>
                                    </div>
                                </Row>
							</ContainerCol>
						</Row>
					</ModalContainer>
				</ModalResponsive>
                <ModalResponsive closeOut={true} open={this.state.isModalDetalleCobranzaVisible} onClose={() => this.setState({isModalDetalleCobranzaVisible:false})}>
					<ModalContainer>
						<Row>
							<ContainerCol className='col-xs-12 col-sm-12' align="center">
								<h4><strong>Detalle Cobranza</strong></h4>
								<Hr />
							</ContainerCol>
						</Row>
						<Row>
							<ContainerCol className="col-xs-12 col-sm-12">
								<Row>
									<ContainerCol className="col-xs-12 col-sm-12 col-md-12">
										<AgGridRender
											altura='150px'
											data={this.state.detalle_cobranza_data}
											columnas={this.state.detalle_cobranza_columns}
											onGridReady={this.onGridDetalleCobranzaReady}
                                            gridOptions={this.gridDetalleCobranzaOptions}
                                            alturaRow={20}
										/>
									</ContainerCol>
								</Row>
                                <Row>
                                    <div className="col-xs-6 col-sm-6">
                                        <Row>
                                            <ContainerCol className="col-xs-12 col-sm-12">
                                                <PaginationLabels>
                                                    {this.state.pagination.primaraFilaPagina} a {this.state.pagination.ultimaFilaPagina} de {this.state.pagination.totalFilas}
                                                </PaginationLabels>
                                                
                                                <PaginationButtons>
                                                    <div className="btn-group btn-group-xs" role="group">
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleCobranza.paginationGoToFirstPage()}>
                                                            <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                                        </button>
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleCobranza.paginationGoToPreviousPage()}>
                                                            <i className="fa fa-angle-left fa-fw"></i>Anterior
                                                        </button>
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleCobranza.paginationGoToNextPage()}>
                                                            Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                                        </button>
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleCobranza.paginationGoToLastPage()}>
                                                            Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                                        </button>    
                                                        {/* <LabelNota>{'Click derecho para exportar la tabla a excel'}</LabelNota> */}
                                                    </div>   
                                                </PaginationButtons>
                                            </ContainerCol>
                                        </Row>
                                    </div>

                                    <div className="col-xs-12 col-sm-12">
                                        <Row>
                                            <ContainerCol className="col-xs-3 col-sm-3">
                                                <LabelTotales>Total Efectivo: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalEfectivo)}</LabelValorTotales>
                                            </ContainerCol>
                                            <ContainerCol className="col-xs-3 col-sm-3">
                                                <LabelTotales>Total Cheque día-mes: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalCheque)}</LabelValorTotales>
                                            </ContainerCol>
                                            <ContainerCol className="col-xs-3 col-sm-3">
                                                <LabelTotales>Total Cheque Fecha: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalChequePos)}</LabelValorTotales>
                                            </ContainerCol>
                                            <ContainerCol className="col-xs-3 col-sm-3">
                                                <LabelTotales>Total Cobranza: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalDetalleCobranza)}</LabelValorTotales>
                                            </ContainerCol>
                                        </Row>
                                        <Row>
                                            <ContainerCol className="col-xs-6 col-sm-6">
                                                
                                            </ContainerCol>
                                        </Row>
                                    </div>
                                </Row>
							</ContainerCol>
						</Row>
					</ModalContainer>
				</ModalResponsive>
                <ModalResponsive closeOut={true} open={this.state.isModalDetalleEstadoPedidosVisible} onClose={() => this.setState({isModalDetalleEstadoPedidosVisible:false})}>
					<ModalContainer>
						<Row>
							<ContainerCol className='col-xs-12 col-sm-12' align="center">
								<h4><strong>Estado de Pedidos</strong></h4>
								<Hr />
                                <ToggleSwitch
                                checked={this.state.visualizarAtendidos}
                                onChange={(event) => {this.cargarDatosEstadosPedidoEspecifico()}}
                                size='sm'
                                />
                             <LabelTipoProf>Ver Solamente Pedidos no atendidos</LabelTipoProf>
							</ContainerCol>
						</Row>
						<Row>
							<ContainerCol className="col-xs-12 col-sm-12">
								<Row>
									<ContainerCol className="col-xs-12 col-sm-12 col-md-12">
										<AgGridRender
											altura='120px'
											data={this.state.detalle_estado_pedido_data}
											columnas={this.state.detalle_estado_pedido_columns}
											onGridReady={this.onGridDetalleEstadoPedidoReady}
                                            gridOptions={this.gridDetalleEstadoPedido}
                                            alturaRow={20}
										/>
									</ContainerCol>
								</Row>
                                <Row>
                                    <div className="col-xs-6 col-sm-6">
                                        <Row>
                                            <ContainerCol className="col-xs-12 col-sm-12">
                                                <PaginationLabels>
                                                    {this.state.pagination.primaraFilaPagina} a {this.state.pagination.ultimaFilaPagina} de {this.state.pagination.totalFilas}
                                                </PaginationLabels>
                                                
                                                <PaginationButtons>
                                                    <div className="btn-group btn-group-xs" role="group">
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleEstadoPedido.paginationGoToFirstPage()}>
                                                            <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                                        </button>
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleEstadoPedido.paginationGoToPreviousPage()}>
                                                            <i className="fa fa-angle-left fa-fw"></i>Anterior
                                                        </button>
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleEstadoPedido.paginationGoToNextPage()}>
                                                            Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                                        </button>
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleEstadoPedido.paginationGoToLastPage()}>
                                                            Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                                        </button>    
                                                        {/* <LabelNota>{'Click derecho para exportar la tabla a excel'}</LabelNota> */}
                                                    </div>   
                                                </PaginationButtons>
                                            </ContainerCol>
                                        </Row>
                                    </div>

                                    <div className="col-xs-12 col-sm-12">
                                        <Row>
                                            <ContainerCol className="col-xs-4 col-sm-4">
                                                <LabelTotales>Total Pedido: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalValorPedido)}</LabelValorTotales>
                                            </ContainerCol>
                                            <ContainerCol className="col-xs-4 col-sm-4">
                                                <LabelTotales>Total Proforma: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalValorProforma)}</LabelValorTotales>
                                            </ContainerCol>
                                            <ContainerCol className="col-xs-4 col-sm-4">
                                                <LabelTotales>Total Proforma Tran.: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalValorProformaTransito)}</LabelValorTotales>
                                            </ContainerCol>
                                            <ContainerCol className="col-xs-4 col-sm-4">
                                                <LabelTotales>Total Facturado: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalValorFacturado)}</LabelValorTotales>
                                            </ContainerCol>
                                            <ContainerCol className="col-xs-4 col-sm-4">
                                                <LabelTotales>Total General: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalGeneral)}</LabelValorTotales>
                                            </ContainerCol>
                                            <ContainerCol className="col-xs-4 col-sm-4">
                                                <LabelTotales>Total No Atendido: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalNoAtendido)}</LabelValorTotales>
                                            </ContainerCol>
                                        </Row>
                                    </div>
                                </Row>
							</ContainerCol>
						</Row>
					</ModalContainer>
				</ModalResponsive>
                <ModalResponsive closeOut={true} open={this.state.isModalDetalleArticuloPedidosVisible} onClose={() => this.setState({isModalDetalleArticuloPedidosVisible:false})}>
					<ModalContainer>
						<Row>
							<ContainerCol className='col-xs-12 col-sm-12' align="center">
								<h4><strong>No Pedido: {this.state.numero_pedido_movil_seleccionado}</strong></h4>
								<Hr />
							</ContainerCol>
						</Row>
						<Row>
							<ContainerCol className="col-xs-12 col-sm-12">
								<Row>
									<ContainerCol className="col-xs-12 col-sm-12 col-md-12">
										<AgGridRender
											altura='130px'
											data={this.state.detalle_articulos_pedido}
											columnas={this.state.detalle_articulos_pedido_columns}
											onGridReady={this.onGridDetalleArticuloPedidoReady}
                                            gridOptions={this.gridDetalleArticuloPedidoOptions}
                                            alturaRow={20}
										/>
									</ContainerCol>
								</Row>
                                <Row>
                                    <div className="col-xs-6 col-sm-6">
                                        <Row>
                                            <ContainerCol className="col-xs-12 col-sm-12">
                                                <PaginationLabels>
                                                    {this.state.pagination.primaraFilaPagina} a {this.state.pagination.ultimaFilaPagina} de {this.state.pagination.totalFilas}
                                                </PaginationLabels>
                                                
                                                <PaginationButtons>
                                                    <div className="btn-group btn-group-xs" role="group">
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleArticuloPedido.paginationGoToFirstPage()}>
                                                            <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                                        </button>
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleArticuloPedido.paginationGoToPreviousPage()}>
                                                            <i className="fa fa-angle-left fa-fw"></i>Anterior
                                                        </button>
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleArticuloPedido.paginationGoToNextPage()}>
                                                            Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                                        </button>
                                                        <button style={{height:'30px'}} className="btn btn-default" onClick={() => this.apiDetalleArticuloPedido.paginationGoToLastPage()}>
                                                            Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                                        </button>    
                                                        {/* <LabelNota>{'Click derecho para exportar la tabla a excel'}</LabelNota> */}
                                                    </div>   
                                                </PaginationButtons>
                                            </ContainerCol>
                                        </Row>
                                    </div>
                                </Row>
							</ContainerCol>
						</Row>
					</ModalContainer>
				</ModalResponsive>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
        permiso: state.sesion.valoresSesionForm.Permiso,
        usuario: state.sesion.valoresSesionForm.Usuario,
        tipo_usuario: state.sesion.valoresSesionForm.TipoUsuario,
        facturas: state.vendedores.facturas,
        devoluciones: state.vendedores.devoluciones,
        descuentos: state.vendedores.descuentos,
        proformas: state.vendedores.proformas,
        pedidoProcesos: state.vendedores.pedidoProcesos,
        articulosPedido: state.vendedores.articulosPedido
    }
});
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,cambiar_VisualizacionLoading,cargarFacturasFecha, cargarDevolucionesFecha,cargarDescuentosFecha, cargarProformasFecha, cargarPedidoProcesoPorFecha, cargarArticulosPedidoFecha}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormVende01);